export const environment = {
    production: false,
    siteName: 'Client Staging',
    baseUrl: 'https://hm.askantech.com/',
  };